import React from 'react';

import { Layout, Link, Text } from 'ds';

interface Props {}

const CleaningServiceLegalText: React.FC<Props> = () => {
  return (
    <Layout>
      <Text size="tag" color="gray-400">
        Your payment method will be charged twice monthly, on the 1st and 16th, for any completed unpaid cleanings. You
        authorize charges for future additional cleaning services. Prices are subject to change as per Codi’s{' '}
        <Link href="/terms">
          <Text color="gray-400" size="tag" underline inline __style={{ textUnderlineOffset: '2px' }}>
            Terms of Service
          </Text>
        </Link>
        . You may cancel at any time, subject to the refund policy detailed in Codi’s{' '}
        <Link href="/terms#managed-services">
          <Text color="gray-400" size="tag" underline inline __style={{ textUnderlineOffset: '2px' }}>
            Managed Services Terms
          </Text>
        </Link>
        . By clicking 'Start service', you acknowledge that you have read, understood, and agreed to Codi's{' '}
        <Link href="/terms#managed-services">
          <Text color="gray-400" size="tag" underline inline __style={{ textUnderlineOffset: '2px' }}>
            Managed Services Terms
          </Text>
        </Link>
        , which are incorporated into Codi's{' '}
        <Link href="/terms">
          <Text color="gray-400" size="tag" underline inline __style={{ textUnderlineOffset: '2px' }}>
            Terms of Service
          </Text>
        </Link>
        .
      </Text>
    </Layout>
  );
};

export default CleaningServiceLegalText;
